import _ from 'lodash';
import { compose } from 'redux';

const createMiddlewareInjector = () => {
  let injectedMiddlewares = [];

  const addMiddleware = (middleware) => {
    injectedMiddlewares = [...injectedMiddlewares, middleware];

    // Returns a function to remove added middleware
    return () => {
      _.remove(injectedMiddlewares, (m) => m === middleware);
    };
  };

  // middlewareInjector is always injected and executes all of the injected middlewares
  const middlewareInjector = (store) => (next) => (action) =>
    compose(...injectedMiddlewares.map((m) => m(store)))(next)(action);

  return {
    middlewareInjector,
    addMiddleware,
  };
};

export const { middlewareInjector, addMiddleware } = createMiddlewareInjector();

export default createMiddlewareInjector;
